/**
 * @author: subhasish.ghosh@zoom.us
 */

import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import { TAB, TABLE_TYPES, TABLE_TYPES_KEYS } from "@utils/constants";
import { useSearchParams } from "react-router-dom";
import { getIndexOfTableTab, getTableTabFromIndex } from "@utils/utils";
import flags from "@flags";

const CancellationTableTab = ({ setSelectedTableTab }) => {
  const [urlSearchParams, setURLSearchParams] = useSearchParams();

  const [currentTableTab, setCurrentTableTab] = useState();

  const handleTabChange = (event, newTab) => {
    setCurrentTableTab(newTab);
    setSelectedTableTab(getTableTabFromIndex(newTab));
  };

  useEffect(() => {
    // handle tab param
    if (typeof currentTableTab === "number") {
      const tabName = TABLE_TYPES_KEYS[currentTableTab];
      if (tabName && tabName !== null) {
        urlSearchParams.set("tab", tabName);
        setURLSearchParams(urlSearchParams);
      }
    }
  }, [currentTableTab]);

  useEffect(() => {
    const searchParamTableTab = urlSearchParams.get(TAB);

    // handle selected table tab
    if (
      searchParamTableTab &&
      TABLE_TYPES.hasOwnProperty(searchParamTableTab)
    ) {
      setCurrentTableTab(getIndexOfTableTab(searchParamTableTab));
      setSelectedTableTab(searchParamTableTab);
    } else {
      // incase no table tab is provided in uri
      const defaultTab = TABLE_TYPES_KEYS[0];
      setCurrentTableTab(0);
      setSelectedTableTab(defaultTab);
    }
  }, [urlSearchParams, setSelectedTableTab]);

  // search param changes are handled by TopBar component

  return (
    <Tabs
      value={currentTableTab || 0}
      onChange={handleTabChange}
      variant="scrollable"
      scrollButtons={false}
      sx={{ marginBottom: "20px" }}
    >
      <Tab label="Pending Action" value={0} sx={{ paddingLeft: "0" }} />
      <Tab label="Historical Records" value={1} />
    </Tabs>
  );
};

export default CancellationTableTab;
